export default {
    values: {
        "Service provider for this process": "Provedor de serviços para este processo",
        "Imagelog chart editor": "Visualizador de perfil de imagem de poço",
        "Check if the active run has a linked service provider and if the mappings are registered": "Verifique se a corrida ativa possui provedor de serviços vinculado e se os mapeamentos estão cadastrados",
        "ImageLog standard": "ImageLog padrão",
        "Image Type": "Tipo de imagem",
        "Test well": "Poço de teste",
        "Color pattern": "Padrão de cores",
        "Use default min/max": "Padrão min/max",
        "Interpolate": "Interpolar",
        "Size of axes area": "Tamanho da área do eixo",
        "Hide values": "Esconder valores",
        "X axis": "Eixo X",
        "Y axis": "Eixo Y",
        "Image Log Mappings": "Mapeamento de Imagelog",
        "Yellow/Orange/Brown": "Amarelo/Laranja/Marrom",
        "Yellow/Orange/Red": "Amarelo/Laranja/Vermelho",
        "Yellow/Green/Blue": "Amarelo/Verde/Azul",
        "Invalid color scale type": "Escala de cor inválida",
        "Drilling Service Provider": "Provedor de serviços de perfuração",
        "Mnemonic": "Mnemonico",
        "Standard Color Pattern": "Padrão de cores padrão",
        "Select color pattern": "Selecionar padrão de cor",
        "No options found": "Nenhuma opção encontrada",
        "Select image type": "Selecinar tipo de imagem"
    }
}
